import { resolveImage } from "../lib/api";

export default function HorseImage({ photo, alt, className = "", fallbackClass = "" }) {
  const src = resolveImage(photo);
  if (!src)
    return (
      <div
        className={`flex items-center justify-center bg-[#F0EAE1] text-[#8C532B] ${className} ${fallbackClass}`}
      >
        <span className="font-display font-bold text-lg">
          {(alt || "?").slice(0, 2).toUpperCase()}
        </span>
      </div>
    );
  return <img src={src} alt={alt} className={`object-cover ${className}`} loading="lazy" />;
}
